const BenefitCard = ({ item, index }) => {
    const { title, text, type } = item;

    return (
        <div key={title} className={`benefit-card ${type ? `benefit-card__${type}` : ''}`}>
            <div className="gradient-number dark">
                <span>{index + 1}</span>
            </div>
            {title && <div className="description-demibold benefit-card__title">{title}</div>}
            <div className="body1 opacity-80 benefit-card__text">{text}</div>
        </div>
    );
};

export default BenefitCard;
